import { AdapterProtocol } from "../flatbuffers/generated/archive/adapter-protocol";
import { ChannelMode } from "../flatbuffers/generated/archive/channel-mode";
import { ChannelType } from "../flatbuffers/generated/archive/channel-type";
import { SessionProtocol } from "../flatbuffers/generated/session/session-protocol";

/**
 * Adapter protocols whose Ethernet module VTS reaches over telnet, where the
 * module asks for a login before it takes a command — by the generated enum's
 * names, the form the Banks step resolves an adapter's protocol to.
 */
const NUMATO_TELNET_PROTOCOLS: ReadonlySet<string> = new Set([
  AdapterProtocol[AdapterProtocol.NUMATORELAY],
  AdapterProtocol[AdapterProtocol.NUMATOGPIO],
]);

/** The channel facts the Banks step's Numato session warning reads. */
export interface NumatoSessionChannel {
  connectionType: ChannelType | null;
  mode: ChannelMode;
  sessionProtocol: SessionProtocol;
}

/**
 * Whether a bank pairs a Numato adapter with a channel that reaches its module
 * over TCP with no session protocol. VTS then logs in with the placeholder
 * every CDO entry carries (`user` / `password`), which a real module refuses
 * unless those are its credentials, so the operator should give the channel a
 * Telnet session with the module's login. A non-SINGLE channel cannot carry a
 * session at all, so there is nothing to suggest and no warning.
 */
export function numatoNeedsSession(
  adapterProtocol: string,
  channel: NumatoSessionChannel,
): boolean {
  return (
    NUMATO_TELNET_PROTOCOLS.has(adapterProtocol.toUpperCase()) &&
    channel.connectionType === ChannelType.TCP &&
    channel.mode === ChannelMode.SINGLE &&
    channel.sessionProtocol === SessionProtocol.None
  );
}

/**
 * A channel row's connection type, from either response shape: the
 * FlatBuffer one carries the generated enum's number, a JSON one its name.
 * `null` when the row says nothing recognisable.
 */
export function channelTypeOf(raw: unknown): ChannelType | null {
  if (typeof raw === "number" && raw in ChannelType) return raw as ChannelType;
  if (typeof raw === "string") {
    const value = (ChannelType as unknown as Record<string, unknown>)[raw.toUpperCase()];
    if (typeof value === "number") return value as ChannelType;
  }
  return null;
}
